module.exports = __webpack_public_path__ + "img/HN.9bfa644f.svg";